import { render, staticRenderFns } from "./VBlockWrapper.vue?vue&type=template&id=641d93da&"
import script from "./VBlockWrapper.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VBlockWrapper.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VBlockWrapper.vue?vue&type=style&index=0&id=641d93da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports